module.exports = __webpack_public_path__ + "img/logo.540cc6b4.jpg";